
const lang = {
    en: {
        Search: "Search",
        gptSearchPlaceholder: "What would you like to watch ?",
    },
    hn: {
        Search: "खोज",
        gptSearchPlaceholder: "आज आप क्या देखना चाहेंगे?"
    },
    spn: {
        Search: "Buscar",
        gptSearchPlaceholder: "¿Qué te gustaría ver hoy?"
    },
    zpn: {
        Search: "検索",
        gptSearchPlaceholder: "今日は何を見たいですか？"
    },
}

export default lang;